import React from "react";

const Camparison = () => {
  let serial = 1;
  return (
    <div>
      <div className="p-4 ps-2">
        <h3
          style={{
            fontSize: "2.7rem",
          }}
          className="pb-3"
        >
          Why <span style={{ color: "green" }}>KRYZEN BIOTECH </span> Structure
        </h3>
        <h3
          style={{
            fontSize: "2.7rem",
          }}
        >
          over any other fabricators?
        </h3>
      </div>

      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "3%" }}>Sr.</th>
            <th style={{ width: "19%" }}>FEATURES</th>
            <th className="bg-green-lt" style={{ width: "39%" }}>
              KRYZEN
            </th>
            <th className="bg-red-lt" style={{ width: "39%" }}>
              OTHERS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}</td>
            <td>Height of Structure</td>
            <td className="bg-green-lt">6.8M to 7.5M from Ground Level</td>
            <td className="bg-red-lt">6.2M to 6.5M from Ground Level</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Side Ventilation</td>
            <td className="bg-green-lt">4M</td>{" "}
            <td className="bg-red-lt">2.5M</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Top Vent</td>
            <td className="bg-green-lt">1.2M to 1.4M</td>{" "}
            <td className="bg-red-lt">0.8 M to 0.9M</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Pipe Quality and Galvanization</td>
            <td className="bg-green-lt">375 GSM to 400 GSM</td>{" "}
            <td className="bg-red-lt">150 GSM to 400 GSM</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Nut Bolts and Connectors</td>
            <td className="bg-green-lt">
              22 Micron Zinc Coated, Main Connectors are 5mm Zinc Coated
            </td>
            <td className="bg-red-lt">
              No Coating / Color Coating resulting in rusting in 6 months
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Foundation</td>
            <td className="bg-green-lt">
              76mm Diameter, 2mm Thickness, Crimped Foundation Gives More
              Strength
            </td>
            <td className="bg-red-lt">
              63mm Diameter, 1.6mm Thickness, Point Load Foundation is less
              stable
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Door</td>
            <td className="bg-green-lt">
              Aluminium Double Sliding Door with Buffer Zone
            </td>
            <td className="bg-red-lt">
              Basic Non-Sliding, FRP Door without Buffer Zone or small buffer
              zone
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Decaontamination Cabin</td>
            <td className="bg-green-lt">
              3M to 4M length and width with 3M height at entrance of structure.
            </td>
            <td className="bg-red-lt">
              No Decantamination zone or very small of 2M to 2.5M zone.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Gutter</td>
            <td className="bg-green-lt">
              1.6mm Thickness, 275 GSM Zinc Coated Gutters
            </td>
            <td className="bg-red-lt">
              0.6mm to 1mm Thickness Non-Galvanized Gutters
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>End Gutters</td>
            <td className="bg-green-lt">
              Yes, with facilities connected to rain water harvesting
            </td>
            <td className="bg-red-lt">
              To save cost, Gutters are folded at the end leaving no room to
              recollectt he water.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Shade Net Mechanism</td>
            <td className="bg-green-lt">
              Pulley System Hybrid Mechanism, The Shade Net moves with hundreds
              of pulleys and sandwich clips which are well designed for easy
              movement without tearing the shade net. PVC wire is used in this
              Mechanism.
            </td>
            <td className="bg-red-lt">
              Hook Mechanism, The hook tears the shade net in 1 year and damages
              the shade net., GI wire is used in this Mechanism. Rusting will
              tear the Shade net.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Reinforcement and Anti-Wind Breakers</td>
            <td className="bg-green-lt">
              We provide multiple reinforcement and anti-wind breakers for the
              strength of the structure.
            </td>
            <td className="bg-red-lt">No reinforcements are given.</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Tonnage of Structure</td>
            <td className="bg-green-lt">
              Upto 1.8 times more weight of similar size structure. Can be
              measured at the site.
            </td>
            <td className="bg-red-lt">
              Weights less, as partial components are of 2MM but most of them
              are at 1.5MM, also less reinforced GI material.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Profile</td>
            <td className="bg-green-lt">
              Aluminium Profile, Heat doesn’t transfer and increases the life of
              Plastic.
            </td>
            <td className="bg-red-lt">
              GI Profile, Heats plastic and damages it
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Spring</td>
            <td className="bg-green-lt">
              PVC-Coated/Aluminium Springs Don’t heat the plastic
            </td>
            <td className="bg-red-lt">
              GI spring., Heats the plastic and damages it.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Polyfilm</td>
            <td className="bg-green-lt">
              ISI Marked, Anti dust, Anti drip, Anti punchure, long lasting, 7
              layers with UV & IR blocking polyfilm of 200Micron
            </td>
            <td className="bg-red-lt">
              150Micron to 200Micron 5 layer polyfilm
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Multiple Designed Connectors</td>
            <td className="bg-green-lt">
              Israeli-designed connectors are used for better strength of the
              structure.
            </td>
            <td className="bg-red-lt">Local Connectors</td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default Camparison;
